import React from 'react';
import { FileProps } from '../file.props';
import { Flex, Text } from 'common/common-components.styled';
import { useTheme } from 'styled-components';
import { TooltipComponent } from 'components/tooltip-component/tooltip-component';
import { TriangleExclamationMarkIcon } from 'components/icons-new/triangle-exclamation-mark';
import { MimeTypes } from 'common/enums';

export const FileAcceptInfo = ({ dropzoneOptions }: Pick<FileProps, 'dropzoneOptions'>) => {
  const theme = useTheme();

  const fileFormats = dropzoneOptions?.accept;
  const fileMaxSize = dropzoneOptions?.maxSize;
  const fileMaxFiles = dropzoneOptions?.maxFiles;

  const getFileAcceptFormatString = () => {
    if (!fileFormats) {
      return '';
    }

    if (Array.isArray(fileFormats)) {
      const formatsArray = fileFormats.map(type => {
        if (type === MimeTypes.XLSX) {
          return 'XLSX';
        }
        if (type === MimeTypes.XLS) {
          return 'XLS';
        }
        if (type === MimeTypes.TXT) {
          return 'TXT';
        }

        return type.split('/')[1] || type.replace('.', '');
      });

      return formatsArray.join(', ').toUpperCase();
    }

    return fileFormats;
  };

  const getAcceptString = () => {
    const acceptFormatString = getFileAcceptFormatString();
    let acceptString = '';

    if (acceptFormatString) {
      acceptString = `Hier kannst Du Dateien mit dem Format ${acceptFormatString}`;
    }

    if (fileMaxSize) {
      acceptString = `${acceptString} mit einer max. Dateigröße von ${fileMaxSize / 1024 / 1024} MB hochladen`;
    }

    if (fileMaxFiles) {
      acceptString = `${acceptString}. Es können maximal ${fileMaxFiles} Dateien hochgeladen werden`;
    }

    return `${acceptString}.`;
  };

  if (!dropzoneOptions?.accept) {
    return null;
  }

  return (
    <Flex justify='flex-end'>
      <TooltipComponent title={getAcceptString()}>
        <Flex align='center' top='10' pointer>
          <Text color='grey500' size='12' right='5'>
            Zulässige Formate
          </Text>

          <TriangleExclamationMarkIcon color={theme.colors.grey500} />
        </Flex>
      </TooltipComponent>
    </Flex>
  );
};
